import './display.css'

// Context / breadcrumb strip. Pass a `title` for a single truncating label, or
// `children` for richer content (breadcrumbs, search summary, ...).
function DisplayLocationBar({ title, children }) {
  return (
    <div className="display-locationbar">
      {children != null ? (
        children
      ) : (
        <span className="display-location-text">{title}</span>
      )}
    </div>
  )
}

export default DisplayLocationBar
